

export class ParametrosVisitanteModel {

    nombreONumeroDocumento: string;
    ordenamiento: string;
    tipoIdVisitante: string;
    numeroIdVisitante: string;
    idFuncionario: string;
    numeroIdFuncionario: string;
    filtrodia: boolean;
    estadoVisita: number;



    constructor(nombreONumeroDocumento: string, ordenamiento: string, tipoIdVisitante: string,
                numeroIdVisitante: string, idFuncionario: string, numeroIdFuncionario: string,
                filtrodia: boolean, estadoVisita: number) {

        this.nombreONumeroDocumento = nombreONumeroDocumento;
        this.ordenamiento = ordenamiento;
        this.tipoIdVisitante = tipoIdVisitante;
        this.numeroIdVisitante = numeroIdVisitante;
        this.idFuncionario = idFuncionario;
        this.numeroIdFuncionario = numeroIdFuncionario;
        this.filtrodia = filtrodia;
        this.estadoVisita = estadoVisita;
    }



}
